import { Button as ButtonSystem, axiomTokens } from '@iclinic/design-system';
import styled from 'styled-components';

export const Container = styled.div`
  position: relative;
  display: inline-block;
`;

export const List = styled.div`
  display: block;
  position: absolute;
  right: 0;
  background-color: ${axiomTokens.color.background[1]};
  min-width: 160px;
  box-shadow: 0px ${axiomTokens.border.radius.md}
    ${axiomTokens.border.radius.lg} 0px rgba(0, 0, 0, 0.2);
  z-index: 1;

  li {
    display: block;
  }
`;

export const Button = styled(ButtonSystem)({
  width: '100%',
  color: axiomTokens.color.branding[10],
  fontWeight: 'normal',
  '&:hover, &:focus': {
    backgroundColor: axiomTokens.color.background[3],
    outline: 'none',
    textDecoration: 'none',
  },
});
